import React from "react";
import { Component } from "react";
import {
  View,
  Text,
  Image,
  TextInput,
  Platform,
  TouchableOpacity,
} from "react-native";
import { Picker } from "@react-native-picker/picker";
import styles from "../../styles/monthlyStyle";
import internetBankImage from "../../../assets/images/internetBanking.png";
import arrowUp from "../../../assets/images/arrowforward.png";
import arrowDown from "../../../assets/images/arrowdown.png";
import HocComponent from "../../commonComponents/Hoc";
import Header from "../../commonComponents/Header";
import { decrypt } from "../../utils/encryption";
import apis from "../../services/api-services";
import { OTP_PAYMENT } from "../../constants/routePaths";
import KeyboardAwareScrollView from "../KeyboardAwareScrollView";
import CustomDropDownV2 from "../../commonComponents/CustomDropdownV2";
import { renderers } from "react-native-popup-menu";
const regexOnlyNumber = /^[0-9 ]*$/;

const { NotAnimatedContextMenu } = renderers;
const regexOnlyText = /^[a-zA-Z. ]*$/;

// Monthly Paymennt Screen;
class MonthlyPayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customerId: "",
      redirect: "",
      inputArray: [
        {
          type: "text",
          placeholder: "Customer Name*",
          name: "Customer Name",
          errorMsg: "Please enter valid Customer Name",
          correct: true,
          value: "",
          visible: true,
          maxLength: 100,
          keyboardType: "default",
        },
        {
          type: "dropdown",
          placeholder: "Bank Name*",
          name: "Bank Name",
          errorMsg: "Please enter valid Bank Name",
          correct: true,
          value: "",
          visible: true,
          maxLength: 100,
          keyboardType: "default",
          bankArray: ["Bank1", "Bank2", "Bank3", "Bank4", "Bank5"],
          enableDefaultValue: true,
        },
        {
          type: "text",
          placeholder: "Please enter 16 digit Account Number*",
          name: "Account Number",
          errorMsg: "Please enter valid Account Number",
          correct: true,
          value: "",
          visible: true,
          maxLength: 19,
          keyboardType: "numeric",
        },
        {
          type: "text",
          placeholder: "Please enter 6 digit Routing/Sort Code*",
          name: "Sort Code",
          errorMsg: "Please enter valid Sort Code",
          correct: true,
          value: "",
          visible: true,
          maxLength: 8,
          keyboardType: "numeric",
        },
      ],
      fareAmount: "",
      monthlyAmount: "",
      disableSubmit: false,
      selectedValue: "",
      visibleDropDown: false,
      width: 0,
    };
  }

  componentDidMount() {
    let urlData;
    if (Platform.OS === "web" && window.location.search) {
      let encrypteddata = window.location.search.replace("?data=", "");
      urlData = JSON.parse(decrypt(encrypteddata));
    } else {
      // get encrypted data for mbl
      const encrypteddata = this.props.route.params["data"];
      urlData = JSON.parse(decrypt(encrypteddata));
    }
    this.setState({
      customerId: urlData.Id,
      redirect: urlData.No ? process.env.WHATSAPP_LINK + urlData.No : false,
      fareAmount: parseFloat(urlData.Amt).toFixed(2),
      monthlyAmount: (parseFloat(urlData.Amt) / 12).toFixed(2),
    });
  }
  // onchange TextInput
  textInputChange = (name, val, index, sectionName) => {
    var config = this.state.inputArray;

    switch (name) {
      case "Customer Name":
        try {
          for (var i = 0; i < config.length; i++) {
            if (config[i].name == name && regexOnlyText.test(val)) {
              config[i].value = val;
              config[i].correct = true;
            }
          }
        } catch (e) {}
        break;
      case "Bank Name":
        try {
          for (var i = 0; i < config.length; i++) {
            if (config[i].name == name) {
              config[i].value = val;
              config[i].correct = true;
              config[i].enableDefaultValue = false;
            }
          }
        } catch (e) {}
        break;

      case "Account Number":
        try {
          for (var i = 0; i < config.length; i++) {
            if (config[i].name == name && regexOnlyNumber.test(val)) {
              config[i].value = val
                .replace(/\s?/g, "")
                .replace(/(\d{4})/g, "$1 ")
                .trim();
              config[i].correct = true;
            }
          }
        } catch (e) {}
        break;

      case "Sort Code":
        try {
          for (var i = 0; i < config.length; i++) {
            if (config[i].name == name) {
              let newVal =
                val.length != 0
                  ? val.match(/\d{2}(?=\d{2})|\d+/g).join("-")
                  : "";
              config[i].value = newVal;
              config[i].correct = true;
            }
          }
        } catch (e) {}
    }
    this.setState({ inputArray: config });
  };

  getHeader = () => {
    const { selectedValue, visibleDropDown } = this.state;
    return (
      <View
        style={styles.headerStyle}
        onLayout={(event) =>
          this.setState({ width: event.nativeEvent.layout.width })
        }
      >
        <View style={{ flexDirection: "row" }}>
          <Text
            style={[
              styles.dropDownHeaderTextSTyle,
              { color: selectedValue ? "black" : "#a9a9a9" },
            ]}
          >
            {selectedValue ? selectedValue : "Bank Name*"}
          </Text>
          <Image
            style={{ width: 20, height: 20 }}
            source={visibleDropDown ? arrowDown : arrowDown}
          ></Image>
        </View>
      </View>
    );
  };

  menuOptionComponent = (props) => {
    return (
      <View>
        <Text style={{ fontFamily: "SFProText", marginVertical: 3 }}>
          {props}
        </Text>
      </View>
    );
  };

  onSelectOption = (value) => {
    this.setState({
      selectedValue: value,
    });
  };
  // TextInput UI render
  renderTextInputs = () => {
    const textInputResponsive = `textInputResponsive_${this.props.measure}`;
    const textInputView = `textInputView_${this.props.measure}`;
    const textInputErrorView = `textInputErrorView_${this.props.measure}`;

    return this.state.inputArray.map((item, index) => {
      if (item.type == "dropdown") {
        return (
          <View
            nativeID={`inputField_${index}`}
            style={
              Platform.OS !== "web"
                ? { width: "100%" }
                : [styles.textInputView, styles[textInputView]]
            }
          >
            {Platform.OS !== "web" ? (
              <View style={{ width: "100%", paddingBottom: 20 }}>
                <CustomDropDownV2
                  styleMenuOptions={{
                    width: this.state.width ? this.state.width : "100%",
                    marginTop: 48,
                  }}
                  menuOptionHeader={this.getHeader}
                  menuOptionComponent={this.menuOptionComponent}
                  menuOptionDataArray={this.state.inputArray[index].bankArray}
                  propRenderer={NotAnimatedContextMenu}
                  preferredPlacement="bottom"
                  onSelectionOption={(value) =>
                    this.onDropDownSelect(item.name, value, index, "")
                  }
                  onMenuOpen={() => this.setState({ visibleDropDown: true })}
                  onMenuClose={() => this.setState({ visibleDropDown: false })}
                />
                {item.correct == false && (
                  <View
                    style={[
                      styles.textInputErrorView,
                      styles[textInputErrorView],
                    ]}
                  >
                    <Text style={styles.textInputError}>{item.errorMsg}</Text>
                  </View>
                )}
              </View>
            ) : (
              <Picker
                selectedValue={item.value}
                onValueChange={(itemValue, index) =>
                  this.textInputChange(item.name, itemValue, index, "")
                }
                style={[
                  styles.textInput,
                  styles[textInputResponsive],
                  styles.borderWidth0,
                ]}
                mode="dropdown"
              >
                {item.enableDefaultValue && (
                  <Picker.Item
                    color="grey"
                    label="Please Select a Bank"
                    value="0"
                  />
                )}
                {item.bankArray.map((bankItem, indx) => {
                  return <Picker.Item label={bankItem} value={bankItem} />;
                })}
              </Picker>
            )}
            {item.correct == false && (
              <View
                style={[
                  styles.textInputErrorView,
                  styles[textInputErrorView],
                  { zIndex: -1 },
                ]}
              >
                <Text style={styles.textInputError}>{item.errorMsg}</Text>
              </View>
            )}
          </View>
        );
      }
      return (
        <View
          nativeID={`inputField_${index}`}
          style={[styles.textInputView, styles[textInputView]]}
        >
          <TextInput
            keyboardType={item.keyboardType}
            style={[styles.textInput, styles[textInputResponsive]]}
            onChangeText={(e) => {
              this.textInputChange(
                item.name,
                e,
                index,
                this.state.inputArray[index].name
              );
            }}
            placeholder={item.placeholder}
            value={item.value}
            maxLength={item.maxLength}
          />
          {item.correct == false && (
            <View
              style={[styles.textInputErrorView, styles[textInputErrorView]]}
            >
              <Text style={styles.textInputError}>{item.errorMsg}</Text>
            </View>
          )}
        </View>
      );
    });
  };

  onSubmit = () => {
    this.setState({
      disableSubmit: true,
    });

    var config = this.state.inputArray;
    var error = true;
    let customerCare = true;
    let bankName = true;
    let accountName = true;
    let sortCode = true;
    for (var i = 0; i < this.state.inputArray.length; i++) {
      if (config[i].name === "Customer Name") {
        if (config[i].value !== "") {
          customerCare = false;
          error = false;
          config[i].correct = true;
        } else {
          customerCare = true;

          error = true;
          config[i].correct = false;
        }

        this.setState({ inputArray: config });
      } else if (config[i].name === "Bank Name") {
        if (config[i].value !== "") {
          bankName = false;
          error = false;
          config[i].correct = true;
        } else {
          bankName = true;

          error = true;
          config[i].correct = false;
        }
        this.setState({ inputArray: config });
      } else if (config[i].name === "Account Number") {
        if (config[i].value !== "" && config[i].value.length === 19) {
          accountName = false;
          error = false;
          config[i].correct = true;
        } else {
          accountName = true;
          error = true;
          config[i].correct = false;
        }
        this.setState({ inputArray: config });
      } else if (config[i].name === "Sort Code") {
        if (config[i].value !== "" && config[i].value.length == 8) {
          sortCode = false;
          error = false;
          config[i].correct = true;
        } else {
          sortCode = true;
          error = true;
          config[i].correct = false;
        }
        this.setState({ inputArray: config });
      }

      if (
        !error &&
        customerCare == false &&
        bankName == false &&
        accountName == false &&
        sortCode == false
      ) {
        let dataToPass = {
          customerId: this.state.customerId,
          fareAmount: this.state.fareAmount,
          debitCardNumber: config[2].value,
          redirect: this.state.redirect,
        };
        if (Platform.OS != "web") {
          this.props.navigation.navigate(OTP_PAYMENT, { state: dataToPass });
        } else {
          this.props.history.push({
            pathname: OTP_PAYMENT,
            state: dataToPass,
          });
        }
      } else if (i === this.state.inputArray.length - 1) {
        this.setState({
          disableSubmit: false,
        });
      }
    }
    // submit validations here;
  };
  onDropDownSelect(name, value, index) {
    this.setState({
      selectedValue: value,
    });
    this.textInputChange(name, value, index, "");
  }
  //UI rendering
  render() {
    const { selectedValue } = this.state;
    const bodyContainer = `bodyContainer_${this.props.measure}`;

    return (
      <View style={styles.mainContainer}>
        <Header
          showHeader={Platform.OS == "web" ? true : false}
          headerText={"Payment Gateway"}
        />
        <KeyboardAwareScrollView>
          <View style={[styles.bodyContainer, styles[bodyContainer]]}>
            <View style={styles.fieldContainers}>
              <Text style={styles.totalAmount}>
                Total Amount is
                <Text
                  style={
                    Platform.OS === "ios"
                      ? styles.amountBoldIOS
                      : styles.amountBold
                  }
                >
                  {" "}
                  £{this.state.fareAmount}
                </Text>
              </Text>
              <Text style={[styles.totalAmount, styles.paddingTopBottom]}>
                Monthly payable amount is
                <Text
                  style={
                    Platform.OS === "ios"
                      ? styles.amountBoldIOS
                      : styles.amountBold
                  }
                >
                  {" "}
                  £{this.state.monthlyAmount}
                </Text>
              </Text>
              <View style={styles.internetBankingImageView}>
                <Image
                  source={internetBankImage}
                  style={styles.internetBankImage}
                />
                <Text style={styles.txtBankDetail}>Bank Details</Text>
              </View>
              {this.renderTextInputs()}
              <View style={styles.paynowBtnView}>
                <TouchableOpacity
                  disabled={this.state.disableSubmit}
                  onPress={() => this.onSubmit()}
                  style={styles.payBtn}
                >
                  <Text style={styles.txtPayNow}>Pay Now</Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </KeyboardAwareScrollView>
      </View>
    );
  }
}

export default HocComponent(MonthlyPayment);
